
<div class="dsk-wrap" *ngIf="loading">
  <div class="dsk-hero">
    <div class="dsk-hero-banner dsk-pulse"></div>
    <div class="dsk-hero-body">
      <div class="dsk-hero-av dsk-pulse"></div>
      <div class="dsk-hero-lines" style="padding-top:28px">
        <div class="dsk-cell dsk-pulse" style="width:160px;height:18px"></div>
        <div class="dsk-cell dsk-pulse" style="width:110px;height:13px"></div>
        <div style="display:flex;gap:8px;margin-top:4px">
          <div class="dsk-chip dsk-pulse" style="width:80px;height:24px"></div>
          <div class="dsk-chip dsk-pulse" style="width:70px;height:24px"></div>
        </div>
      </div>
      <div style="margin-left:auto;display:flex;flex-direction:column;align-items:flex-end;gap:8px;padding-bottom:4px">
        <div class="dsk-cell dsk-pulse" style="width:140px;height:8px;border-radius:20px"></div>
        <div class="dsk-cell dsk-pulse" style="width:80px;height:11px"></div>
      </div>
    </div>
  </div>
  <div class="dsk-split dsk-split-1-2" style="align-items:flex-start">
    <div class="dsk-panel">
      <div class="dsk-panel-body" style="gap:6px;padding:12px">
        <div class="dsk-list-item dsk-pulse" style="height:44px;border-radius:9px" *ngFor="let n of [1,2,3,4,5,6]"></div>
      </div>
    </div>
    <div class="dsk-panel">
      <div class="dsk-panel-head">
        <div class="dsk-cell dsk-pulse" style="flex:1;height:14px"></div>
        <div class="dsk-btn-sm dsk-pulse" style="width:70px;height:30px"></div>
      </div>
      <div class="dsk-panel-body" style="gap:16px;padding:20px 22px">
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:14px" *ngFor="let r of [1,2,3]">
          <div style="display:flex;flex-direction:column;gap:6px">
            <div class="dsk-cell dsk-pulse" style="width:80px;height:11px"></div>
            <div class="dsk-cell dsk-pulse" style="height:36px;border-radius:8px"></div>
          </div>
          <div style="display:flex;flex-direction:column;gap:6px">
            <div class="dsk-cell dsk-pulse" style="width:90px;height:11px"></div>
            <div class="dsk-cell dsk-pulse" style="height:36px;border-radius:8px"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="pf-page" *ngIf="!loading">

  <div class="pf-hero">

    <div class="pf-banner"></div>

    <div class="pf-hero-body">
      <div class="pf-av-wrap">
        <div class="pf-av" *ngIf="!employee.profilePicture">{{ getInitials() }}</div>
        <img class="pf-av-img" *ngIf="employee.profilePicture" [src]="employee.profilePicture" alt="Profile">
        <label class="pf-av-cam" *ngIf="editMode" title="Change photo">
          <mat-icon>photo_camera</mat-icon>
          <input type="file" accept="image/*" (change)="onProfilePictureChange($event)" hidden>
        </label>
      </div>

      <div class="pf-hero-info">
        <div class="pf-name-row">
          <h2 class="pf-name">{{ employee.firstName }} {{ employee.lastName }}</h2>
          <span class="pf-status-chip" [ngClass]="'chip-' + (employee.status || 'active')">
            {{ employee.status || 'Active' | titlecase }}
          </span>
        </div>
        <p class="pf-designation">{{ employee.designation || 'No Designation' }} &nbsp;·&nbsp; {{ getDeptName() }}</p>

        <div class="pf-chips">
          <span class="pf-chip"><mat-icon>badge</mat-icon>{{ employee.employeeId || 'N/A' }}</span>
          <span class="pf-chip"><mat-icon>calendar_today</mat-icon>Joined {{ employee.dateOfJoining || '—' }}</span>
          <span class="pf-chip" *ngIf="employee.employmentType"><mat-icon>work_outline</mat-icon>{{ employee.employmentType | titlecase }}</span>
          <span class="pf-chip pf-chip-mgr" *ngIf="employee.managerName">
            <mat-icon>supervisor_account</mat-icon>Reports to {{ employee.managerName }}
          </span>
        </div>  
      </div>

      <div class="pf-hero-actions">
        <button class="pf-edit-btn" [class.pf-cancel-btn]="editMode" (click)="toggleEdit()">
          <mat-icon>{{ editMode ? 'close' : 'edit' }}</mat-icon>
          {{ editMode ? 'Cancel' : 'Edit Profile' }}
        </button>
      </div>
    </div>

    <div class="pf-completion">
      <div class="pf-completion-label">
        <span>Profile Completion</span>
        <span class="pf-completion-pct">{{ profileCompletion }}%</span>
      </div>
      <div class="pf-completion-track">
        <div class="pf-completion-fill" [style.width.%]="profileCompletion"></div>
      </div>
    </div>

  </div>

  <div class="pf-body">

    <nav class="pf-nav">
      <p class="pf-nav-label">PROFILE SECTIONS</p>
      <div *ngFor="let sec of sections"
           class="pf-nav-item"
           [class.active]="activeSection === sec.key"
           (click)="activeSection = sec.key">
        <span class="pf-nav-icon"><mat-icon>{{ sec.icon }}</mat-icon></span>
        <span class="pf-nav-text">{{ sec.label }}</span>
        <span class="pf-nav-dot" *ngIf="activeSection === sec.key"></span>
      </div>
    </nav>

    <div class="pf-content">
      <form (ngSubmit)="saveProfile()">

        <div *ngIf="activeSection === 'personal'" class="pf-section">
          <div class="pf-section-hdr">
            <mat-icon class="pf-section-icon">person</mat-icon>
            <div>
              <h3 class="pf-section-title">Personal Information</h3>
              <p class="pf-section-desc">Your basic personal and identification details.</p>
            </div>
          </div>
          <div class="pf-grid">
            <div class="pf-field">
              <label class="pf-label">First Name</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.firstName" name="firstName" placeholder="Enter first name">
              <div *ngIf="!editMode" class="pf-value">{{ employee.firstName || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Last Name</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.lastName" name="lastName" placeholder="Enter last name">
              <div *ngIf="!editMode" class="pf-value">{{ employee.lastName || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Date of Birth</label>
              <input *ngIf="editMode" type="date" class="pf-input" [(ngModel)]="employee.dateOfBirth" name="dob">
              <div *ngIf="!editMode" class="pf-value">{{ employee.dateOfBirth || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Gender</label>
              <app-custom-select *ngIf="editMode" [(ngModel)]="employee.gender" name="gender"
                [options]="genderOptions" placeholder="Select Gender"></app-custom-select>
              <div *ngIf="!editMode" class="pf-value capitalize">{{ employee.gender || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Aadhaar Number</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.aadhaarNumber" name="aadhaar" placeholder="XXXX XXXX XXXX">
              <div *ngIf="!editMode" class="pf-value">{{ employee.aadhaarNumber || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">PAN Number</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.panNumber" name="pan" placeholder="AAAAA0000A">
              <div *ngIf="!editMode" class="pf-value">{{ employee.panNumber || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">UAN Number</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.uanNumber" name="uan" placeholder="UAN">
              <div *ngIf="!editMode" class="pf-value">{{ employee.uanNumber || '—' }}</div>
            </div>
          </div>
        </div>

        <div *ngIf="activeSection === 'contact'" class="pf-section">
          <div class="pf-section-hdr">
            <mat-icon class="pf-section-icon">phone</mat-icon>
            <div>
              <h3 class="pf-section-title">Contact Details</h3>
              <p class="pf-section-desc">Your personal and official contact information.</p>
            </div>
          </div>
          <div class="pf-grid">
            <div class="pf-field">
              <label class="pf-label">Personal Email</label>
              <div class="pf-value pf-value-lock">
                <mat-icon class="pf-lock-icon">lock_outline</mat-icon>{{ employee.email || '—' }}
              </div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Official Email</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.officialEmail" name="officialEmail" placeholder="official@company.com">
              <div *ngIf="!editMode" class="pf-value">{{ employee.officialEmail || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Phone Number</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.phone" name="phone" placeholder="+91 XXXXX XXXXX">
              <div *ngIf="!editMode" class="pf-value">{{ employee.phone || '—' }}</div>
            </div>
          </div>
        </div>

        <div *ngIf="activeSection === 'emergency'" class="pf-section">
          <div class="pf-section-hdr">
            <mat-icon class="pf-section-icon pf-icon-red">health_and_safety</mat-icon>
            <div>
              <h3 class="pf-section-title">Emergency Contact</h3>
              <p class="pf-section-desc">A person to be contacted in case of an emergency.</p>
            </div>
          </div>
          <div class="pf-ec-banner" *ngIf="!employee.emergencyContactName && !editMode">
            <mat-icon>info_outline</mat-icon>
            No emergency contact added. Click Edit Profile to add one.
          </div>
          <div class="pf-grid">
            <div class="pf-field">
              <label class="pf-label">Full Name</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.emergencyContactName" name="ecName" placeholder="Contact's full name">
              <div *ngIf="!editMode" class="pf-value">{{ employee.emergencyContactName || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Relationship</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.emergencyRelation" name="ecRelation" placeholder="e.g. Spouse, Parent">
              <div *ngIf="!editMode" class="pf-value">{{ employee.emergencyRelation || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Phone Number</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.emergencyContactPhone" name="ecPhone" placeholder="+91 XXXXX XXXXX">
              <div *ngIf="!editMode" class="pf-value">{{ employee.emergencyContactPhone || '—' }}</div>
            </div>
          </div>
        </div>

        <div *ngIf="activeSection === 'employment'" class="pf-section">
          <div class="pf-section-hdr">
            <mat-icon class="pf-section-icon">work</mat-icon>
            <div>
              <h3 class="pf-section-title">Employment Details</h3>
              <p class="pf-section-desc">Your employment and organizational information (read-only).</p>
            </div>
          </div>
          <div class="pf-grid">
            <div class="pf-field">
              <label class="pf-label">Employee ID</label>
              <div class="pf-value pf-value-lock"><mat-icon class="pf-lock-icon">lock_outline</mat-icon>{{ employee.employeeId || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Department</label>
              <div class="pf-value pf-value-lock"><mat-icon class="pf-lock-icon">lock_outline</mat-icon>{{ getDeptName() }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Designation</label>
              <div class="pf-value pf-value-lock"><mat-icon class="pf-lock-icon">lock_outline</mat-icon>{{ employee.designation || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Employment Type</label>
              <div class="pf-value pf-value-lock capitalize"><mat-icon class="pf-lock-icon">lock_outline</mat-icon>{{ employee.employmentType || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Date of Joining</label>
              <div class="pf-value pf-value-lock"><mat-icon class="pf-lock-icon">lock_outline</mat-icon>{{ employee.dateOfJoining || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Role</label>
              <div class="pf-value pf-value-lock capitalize"><mat-icon class="pf-lock-icon">lock_outline</mat-icon>{{ employee.role || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Employment Status</label>
              <div class="pf-value">
                <span class="pf-badge" [ngClass]="'badge-' + (employee.status || 'active')">{{ employee.status || 'Active' | titlecase }}</span>
              </div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Reporting Manager</label>
              <div class="pf-value pf-value-lock"><mat-icon class="pf-lock-icon">lock_outline</mat-icon>{{ employee.managerName || '—' }}</div>
            </div>
          </div>
        </div>

        <div *ngIf="activeSection === 'bank'" class="pf-section">
          <div class="pf-section-hdr">
            <mat-icon class="pf-section-icon pf-icon-blue">account_balance</mat-icon>
            <div>
              <h3 class="pf-section-title">Bank Details</h3>
              <p class="pf-section-desc">Your salary disbursement bank account information.</p>
            </div>
          </div>
          <div class="pf-info-banner">
            <mat-icon>shield</mat-icon>
            Your bank details are encrypted and only visible to you and payroll administrators.
          </div>
          <div class="pf-grid">
            <div class="pf-field">
              <label class="pf-label">Bank Name</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.bankName" name="bankName" placeholder="e.g. State Bank of India">
              <div *ngIf="!editMode" class="pf-value">{{ employee.bankName || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Account Number</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.bankAccount" name="bankAcct" placeholder="Account number">
              <div *ngIf="!editMode" class="pf-value">{{ employee.bankAccount || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">IFSC Code</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.ifscCode" name="bankIfsc" placeholder="e.g. SBIN0001234">
              <div *ngIf="!editMode" class="pf-value">{{ employee.ifscCode || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Branch Name</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.branchName" name="bankBranch" placeholder="Branch name">
              <div *ngIf="!editMode" class="pf-value">{{ employee.branchName || '—' }}</div>
            </div>
          </div>
        </div>

        <div *ngIf="activeSection === 'address'" class="pf-section">
          <div class="pf-section-hdr">
            <mat-icon class="pf-section-icon">location_on</mat-icon>
            <div>
              <h3 class="pf-section-title">Address</h3>
              <p class="pf-section-desc">Your present and permanent residential address.</p>
            </div>
          </div>

          <p class="pf-sub-title">Present Address</p>
          <div class="pf-grid">
            <div class="pf-field pf-full">
              <label class="pf-label">Address Line 1</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.presentAddressLine1" name="pAddr1" placeholder="House no, street, area">
              <div *ngIf="!editMode" class="pf-value">{{ employee.presentAddressLine1 || '—' }}</div>
            </div>
            <div class="pf-field pf-full">
              <label class="pf-label">Address Line 2</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.presentAddressLine2" name="pAddr2" placeholder="Landmark, locality (optional)">
              <div *ngIf="!editMode" class="pf-value">{{ employee.presentAddressLine2 || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Country</label>
              <app-custom-select *ngIf="editMode" [(ngModel)]="employee.presentCountry" name="pCountry"
                (ngModelChange)="onCountryChange('present', employee.presentCountry)"
                [options]="countries" placeholder="Select Country"></app-custom-select>
              <div *ngIf="!editMode" class="pf-value">{{ employee.presentCountry || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">State</label>
              <app-custom-select *ngIf="editMode" [(ngModel)]="employee.presentState" name="pState"
                (ngModelChange)="onStateChange('present', employee.presentCountry, employee.presentState)"
                [options]="presentStates" [placeholder]="loadingPresentStates ? 'Loading...' : 'Select State'"></app-custom-select>
              <div *ngIf="!editMode" class="pf-value">{{ employee.presentState || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">City</label>
              <app-custom-select *ngIf="editMode && presentCities.length > 0" [(ngModel)]="employee.presentCity" name="pCity"
                [options]="presentCities" [placeholder]="loadingPresentCities ? 'Loading...' : 'Select City'"></app-custom-select>
              <input *ngIf="editMode && presentCities.length === 0" class="pf-input" [(ngModel)]="employee.presentCity" name="pCity" placeholder="Enter city">
              <div *ngIf="!editMode" class="pf-value">{{ employee.presentCity || '—' }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Postal Code</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.presentPostalCode" name="pPostal" placeholder="PIN code">
              <div *ngIf="!editMode" class="pf-value">{{ employee.presentPostalCode || '—' }}</div>
            </div>
          </div>

          <div class="pf-same-toggle" *ngIf="editMode">
            <label>
              <input type="checkbox" [(ngModel)]="employee.sameAsPresentAddress" name="sameAddr">
              Permanent address same as present
            </label>
          </div>

          <p class="pf-sub-title" style="margin-top:20px">Permanent Address</p>
          <div class="pf-grid" *ngIf="!employee.sameAsPresentAddress || !editMode">
            <div class="pf-field pf-full">
              <label class="pf-label">Address Line 1</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.permanentAddressLine1" name="permAddr1" placeholder="House no, street, area">
              <div *ngIf="!editMode" class="pf-value">{{ employee.sameAsPresentAddress ? (employee.presentAddressLine1 || '') : (employee.permanentAddressLine1 || '') }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Country</label>
              <app-custom-select *ngIf="editMode" [(ngModel)]="employee.permanentCountry" name="permCountry"
                (ngModelChange)="onCountryChange('permanent', employee.permanentCountry)"
                [options]="countries" placeholder="Select Country"></app-custom-select>
              <div *ngIf="!editMode" class="pf-value">{{ employee.sameAsPresentAddress ? (employee.presentCountry || '') : (employee.permanentCountry || '') }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">State</label>
              <app-custom-select *ngIf="editMode" [(ngModel)]="employee.permanentState" name="permState"
                (ngModelChange)="onStateChange('permanent', employee.permanentCountry, employee.permanentState)"
                [options]="permanentStates" [placeholder]="loadingPermanentStates ? 'Loading...' : 'Select State'"></app-custom-select>
              <div *ngIf="!editMode" class="pf-value">{{ employee.sameAsPresentAddress ? (employee.presentState || '') : (employee.permanentState || '') }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">City</label>
              <app-custom-select *ngIf="editMode && permanentCities.length > 0" [(ngModel)]="employee.permanentCity" name="permCity"
                [options]="permanentCities" [placeholder]="loadingPermanentCities ? 'Loading...' : 'Select City'"></app-custom-select>
              <input *ngIf="editMode && permanentCities.length === 0" class="pf-input" [(ngModel)]="employee.permanentCity" name="permCity" placeholder="Enter city">
              <div *ngIf="!editMode" class="pf-value">{{ employee.sameAsPresentAddress ? (employee.presentCity || '') : (employee.permanentCity || '') }}</div>
            </div>
            <div class="pf-field">
              <label class="pf-label">Postal Code</label>
              <input *ngIf="editMode" class="pf-input" [(ngModel)]="employee.permanentPostalCode" name="permPostal" placeholder="PIN code">
              <div *ngIf="!editMode" class="pf-value">{{ employee.sameAsPresentAddress ? (employee.presentPostalCode || '') : (employee.permanentPostalCode || '') }}</div>
            </div>
          </div>
          <p *ngIf="employee.sameAsPresentAddress && editMode" class="pf-same-note">Permanent address is same as present address.</p>
        </div>

        <div *ngIf="activeSection === 'education'" class="pf-section">
          <div class="pf-section-hdr">
            <mat-icon class="pf-section-icon pf-icon-blue">school</mat-icon>
            <div>
              <h3 class="pf-section-title">Education</h3>
              <p class="pf-section-desc">Academic qualifications submitted during onboarding.</p>
            </div>
          </div>
          <div *ngIf="candidateEducation.length === 0" class="pf-empty-state">
            <mat-icon>school</mat-icon>
            <p>No education records found. This may not have been filled during onboarding.</p>
          </div>
          <div *ngFor="let edu of candidateEducation; let i = index" class="pf-edu-card">
            <div class="pf-edu-badge">{{ i + 1 }}</div>
            <div class="pf-edu-content">
              <div class="pf-info-grid">
                <div class="pf-info-item" *ngIf="edu.degree"><span class="pf-info-label">Degree</span><span class="pf-info-value">{{ edu.degree }}</span></div>
                <div class="pf-info-item" *ngIf="edu.institution"><span class="pf-info-label">Institution</span><span class="pf-info-value">{{ edu.institution }}</span></div>
                <div class="pf-info-item" *ngIf="edu.board"><span class="pf-info-label">Board / University</span><span class="pf-info-value">{{ edu.board }}</span></div>
                <div class="pf-info-item" *ngIf="edu.yearOfPassing"><span class="pf-info-label">Year of Passing</span><span class="pf-info-value">{{ edu.yearOfPassing }}</span></div>
                <div class="pf-info-item" *ngIf="edu.percentage"><span class="pf-info-label">Percentage / CGPA</span><span class="pf-info-value">{{ edu.percentage }}</span></div>
                <div class="pf-info-item" *ngIf="edu.specialization"><span class="pf-info-label">Specialization</span><span class="pf-info-value">{{ edu.specialization }}</span></div>
              </div>
              <div class="pf-doc-chip" *ngIf="edu.certificateBase64">
                <mat-icon>description</mat-icon>
                <span>{{ edu.certificateFileName || 'Certificate' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="activeSection === 'experience'" class="pf-section">
          <div class="pf-section-hdr">
            <mat-icon class="pf-section-icon pf-icon-green">work_history</mat-icon>
            <div>
              <h3 class="pf-section-title">Work Experience</h3>
              <p class="pf-section-desc">Employment history submitted during onboarding.</p>
            </div>
          </div>
          <div *ngIf="candidateExperience.length === 0" class="pf-empty-state">
            <mat-icon>work_history</mat-icon>
            <p>No experience records found. This may not have been filled during onboarding.</p>
          </div>
          <div *ngFor="let exp of candidateExperience; let i = index" class="pf-edu-card">
            <div class="pf-edu-badge pf-edu-badge--green">{{ i + 1 }}</div>
            <div class="pf-edu-content">
              <div class="pf-info-grid">
                <div class="pf-info-item" *ngIf="exp.companyName"><span class="pf-info-label">Company</span><span class="pf-info-value">{{ exp.companyName }}</span></div>
                <div class="pf-info-item" *ngIf="exp.designation"><span class="pf-info-label">Designation</span><span class="pf-info-value">{{ exp.designation }}</span></div>
                <div class="pf-info-item" *ngIf="exp.fromDate"><span class="pf-info-label">From</span><span class="pf-info-value">{{ exp.fromDate }}</span></div>
                <div class="pf-info-item" *ngIf="exp.toDate"><span class="pf-info-label">To</span><span class="pf-info-value">{{ exp.toDate }}</span></div>
                <div class="pf-info-item" *ngIf="exp.ctc"><span class="pf-info-label">CTC</span><span class="pf-info-value">{{ exp.ctc }}</span></div>
                <div class="pf-info-item" *ngIf="exp.reasonForLeaving"><span class="pf-info-label">Reason for Leaving</span><span class="pf-info-value">{{ exp.reasonForLeaving }}</span></div>
              </div>
              <div *ngIf="exp.responsibilities" class="pf-info-item pf-info-item--full">
                <span class="pf-info-label">Responsibilities</span>
                <span class="pf-info-value">{{ exp.responsibilities }}</span>
              </div>
              <div class="pf-doc-chips">
                <div class="pf-doc-chip" *ngIf="exp.relievingLetterBase64"><mat-icon>description</mat-icon><span>{{ exp.relievingLetterFileName || 'Relieving Letter' }}</span></div>
                <div class="pf-doc-chip" *ngIf="exp.payslip1Base64"><mat-icon>receipt</mat-icon><span>{{ exp.payslip1FileName || 'Payslip 1' }}</span></div>
                <div class="pf-doc-chip" *ngIf="exp.payslip2Base64"><mat-icon>receipt</mat-icon><span>{{ exp.payslip2FileName || 'Payslip 2' }}</span></div>
                <div class="pf-doc-chip" *ngIf="exp.payslip3Base64"><mat-icon>receipt</mat-icon><span>{{ exp.payslip3FileName || 'Payslip 3' }}</span></div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="activeSection === 'documents'" class="pf-section">
          <div class="pf-section-hdr">
            <mat-icon class="pf-section-icon pf-icon-amber">folder_open</mat-icon>
            <div>
              <h3 class="pf-section-title">Documents</h3>
              <p class="pf-section-desc">Upload your identity and employment documents. Max 5 MB per file (PDF, JPG, PNG).</p>
            </div>
          </div>
          <div class="pf-docs-grid">
            <div *ngFor="let docType of documentTypes"
                 class="pf-doc-card"
                 [class.is-uploaded]="getDocumentStatus(docType.key) === 'uploaded'">
              <div class="pf-doc-icon" [class.is-uploaded]="getDocumentStatus(docType.key) === 'uploaded'">
                <mat-icon>{{ docType.icon }}</mat-icon>
              </div>
              <div class="pf-doc-body">
                <span class="pf-doc-name">{{ docType.label }}</span>
                <span class="pf-doc-status" [class.uploaded]="getDocumentStatus(docType.key) === 'uploaded'">
                  <mat-icon>{{ getDocumentStatus(docType.key) === 'uploaded' ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                  <ng-container *ngIf="getDocumentStatus(docType.key) === 'uploaded'">
                    {{ getDoc(docType.key)?.fileName }} &nbsp;·&nbsp; {{ getDocumentDate(docType.key) }}
                  </ng-container>
                  <ng-container *ngIf="getDocumentStatus(docType.key) !== 'uploaded'">Not uploaded</ng-container>
                </span>
                <span class="pf-doc-size" *ngIf="getDoc(docType.key)">
                  {{ formatFileSize(getDoc(docType.key)?.fileSize) }}
                </span>
              </div>

              <div class="pf-doc-actions">
                <label class="pf-doc-upload" [class.uploading]="uploading[docType.key]" title="Upload">
                  <mat-icon *ngIf="!uploading[docType.key]">{{ getDocumentStatus(docType.key) === 'uploaded' ? 'refresh' : 'cloud_upload' }}</mat-icon>
                  <mat-spinner *ngIf="uploading[docType.key]" diameter="16"></mat-spinner>
                  <input type="file" accept=".pdf,.jpg,.jpeg,.png" (change)="onDocumentUpload($event, docType.key)" hidden [disabled]="uploading[docType.key]">
                </label>
                <button class="pf-doc-action-btn" *ngIf="getDocumentStatus(docType.key) === 'uploaded'"
                        (click)="downloadDocument(docType.key)" title="Download">
                  <mat-icon>download</mat-icon>
                </button>
                <button class="pf-doc-action-btn pf-doc-del" *ngIf="getDocumentStatus(docType.key) === 'uploaded'"
                        (click)="deleteDocument(docType.key)" title="Remove">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="activeSection === 'team'" class="pf-section">
          <div class="pf-section-hdr">
            <mat-icon class="pf-section-icon" style="color:#334155">groups</mat-icon>
            <div>
              <h3 class="pf-section-title">My Team</h3>
              <p class="pf-section-desc">Colleagues in your department — {{ getDeptName() }}</p>
            </div>
          </div>

          <div class="pf-team-mgr" *ngIf="employee.managerName">
            <div class="pf-team-av pf-team-av-mgr">{{ employee.managerName | slice:0:1 }}</div>
            <div class="pf-team-info">
              <div class="pf-team-name">{{ employee.managerName }}</div>
              <div class="pf-team-role">Reporting Manager</div>
            </div>
            <span class="pf-team-badge">Manager</span>
          </div>

          <div class="pf-team-grid" *ngIf="teamMembers.length > 0; else noTeam">
            <div class="pf-team-card" *ngFor="let m of teamMembers">
              <div class="pf-team-av">{{ m.initials }}</div>
              <div class="pf-team-info">
                <div class="pf-team-name">{{ m.firstName }} {{ m.lastName }}</div>
                <div class="pf-team-role">{{ m.designation || '—' }}</div>
              </div>
            </div>
          </div>
          <ng-template #noTeam>
            <div class="pf-empty-state"><mat-icon>group_off</mat-icon><span>No other team members found in your department.</span></div>
          </ng-template>
        </div>

        <div class="pf-save-bar" *ngIf="editMode">
          <span class="pf-save-hint"><mat-icon>info_outline</mat-icon> Unsaved changes</span>
          <div class="pf-save-actions">
            <button type="button" class="pf-btn-cancel" (click)="toggleEdit()">Cancel</button>
            <button type="submit" class="pf-btn-save" [disabled]="saving">
              <mat-icon>{{ saving ? 'hourglass_empty' : 'save' }}</mat-icon>
              {{ saving ? 'Saving…' : 'Save Changes' }}
            </button>
          </div>
        </div>

      </form>
    </div>
  </div>

</div>

